AoPS.Utils.initKeyChain(AoPS, "Contests", "Views");

AoPS.Contests.Views = (function (Views) {
	Views.ContestPortalStudentMain = Views.CPGenericSubView.extend({
		template_id: "#contest-portal-student-main-tpl",
		prerenderHelper: function () {
			this.vars = _.extend({}, this.parent.vars);
			this.vars.host_name = this.model.get("master").get("host_name");
			this.vars.coach_name = this.model.get("master").get("coach_name");
			this.vars.coach_email = this.model.get("master").get("coach_email");
			this.vars.academy_url = this.model.get("master").get("academy_url");

			if (this.vars.flavor_is_amc) {
				this.vars.children_aime = [];
				this.vars.children_amc = [];
				this.vars.children_olympiad = [];

				_.each(
					this.vars.children,
					_.bind(function (child) {
						if (child.flavor_is_aime) {
							this.vars.children_aime.push(child);
						} else if (child.flavor_is_maa_olympiad) {
							this.vars.children_olympiad.push(child);
						} else {
							this.vars.children_amc.push(child);
						}
					}, this)
				);
			}

			this.getContestEvents();
			this.filterFAQs("student");

			if (!this.model.get("master").get("isProduction")) {
				console.log(this.vars);
			}
		},
		renderHelper: function () {
			AoPS.Contests.Utils.setFAQsEventListeners();
			AoPS.Contests.Utils.scrollTo();
		},
		getContestEvents: function () {
			var contest_hash = this.model.get("contest_hash");

			// get contest events from /data-aops/cms/contests/objects/events.json
			var contest_events = this.model.get("master").get("contest_events");
			if (contest_events) {
				var events = AoPS.Contests.Utils.processEvents(
					contest_events,
					contest_hash
				);

				this.vars = _.extend(this.vars, events);
				// for the banner
				this.model.set("upcoming_events", events.upcoming_events);

				this.tagEvents();
			}

			return _.extend(this.vars, this.model.export());
		},
		/**
		 * Tags each event object with relevant attributes such as "registered" or "completed"
		 *
		 * @param {Array} events List of events to check
		 * @returns {Array}
		 */
		tagEvents: function () {
			var registered_contests = this.model
				.get("master")
				.get("registered_hashes_individual");
			if (!registered_contests) {
				return;
			}

			this.tagEventsHelper("upcoming_events");
			this.tagEventsHelper("past_events");
		},
		tagEventsHelper: function (str) {
			if (!this.vars[str]) {
				return;
			}
			var is_limited = this.model.get("master").get("is_limited");
			for (var m in this.vars[str]) {
				var month = this.vars[str][m];
				for (var e = 0; e < month.length; e++) {
					if (!is_limited) {
						this.vars[str][m][e].warn_upgrade = false;
					}
					var contest_hashes = month[e].contest_hashes;
					if (!contest_hashes) {
						continue;
					}

					for (var hash of contest_hashes) {
						var contest_model = this.model.getContestModelByHash(hash);
						if (contest_model && contest_model.isRegisteredIndividual()) {
							this.vars[str][m][e].is_registered_individual = true;
							this.vars[str][m][e].is_registered_team =
								contest_model.isRegisteredTeam();
							// is_registered -> registered in either capacity
							this.vars[str][m][e].is_registered =
								contest_model.isRegisteredIndividual() ||
								contest_model.isRegisteredTeam();

							if (contest_model.isCompletedIndividual()) {
								this.vars[str][m][e].is_completed_individual = true;
								if (contest_model.canViewResultsIndividual()) {
									this.vars[str][m][e].can_view_results_individual = true;
									this.vars[str][m][e].action_url_individual =
										contest_model.generateResultsURL();
									this.vars[str][m][e].action_text_individual =
										contest_model.generateEventText(
											false,
											true,
											this.vars.contest_id
										);
								} else {
									this.vars[str][m][e].action_text_individual =
										contest_model.generateEventText(
											false,
											true,
											this.vars.contest_id,
											true
										);
								}
							} else if (
								contest_model.isCurrentIndividual() &&
								contest_model.isStudentPlayable()
							) {
								this.vars[str][m][e].is_current_individual = true;
								this.vars[str][m][e].action_url_individual =
									contest_model.generateIndividualStartURL();
								this.vars[str][m][e].action_text_individual =
									contest_model.generateEventText(
										true,
										true,
										this.vars.contest_id
									);
							}

							if (contest_model.hasTeamContest()) {
								this.vars[str][m][e].has_team_contest = true;
								if (contest_model.isCompletedTeam()) {
									this.vars[str][m][e].is_completed_team = true;
									if (contest_model.canViewResultsTeam()) {
										this.vars[str][m][e].can_view_results_team = true;
										this.vars[str][m][e].action_url_team =
											contest_model.generateResultsURL() + "#team";
										this.vars[str][m][e].action_text_team =
											contest_model.generateEventText(
												false,
												false,
												this.vars.contest_id
											);
									} else {
										this.vars[str][m][e].action_text_team =
											contest_model.generateEventText(
												false,
												false,
												this.vars.contest_id,
												true
											);
									}
								} else if (
									contest_model.isCurrentTeam() &&
									contest_model.isRegisteredTeam() &&
									contest_model.isStudentPlayable()
								) {
									this.vars[str][m][e].is_current_team = true;
									this.vars[str][m][e].action_url_team =
										contest_model.generateTeamStartURL();
									this.vars[str][m][e].action_text_team =
										contest_model.generateEventText(
											true,
											false,
											this.vars.contest_id
										);
								}
							}
						} else {
							this.vars[str][m][e].warn_upgrade = false;
						}
					}
				}
			}
		},
		onEditRegistration: function (e) {
			var $target = $(e.target);
			var contest = this.model.get("master").getWhere("contests", {
				contest_id: parseInt($target.attr("contest_id")),
			});

			if (contest) {
				Backbone.history.navigate(
					this.vars.contest_portal_route + "/" + contest.get("contest_hash"),
					{
						trigger: true,
					}
				);
			}
			e.preventDefault();
		},
	});

	Views.ContestPortalRequireAccountUpgrade = Views.CPGenericSubView.extend({
		template_id: "#contest-portal-require-account-upgrade-tpl",
	});

	return Views;
})(AoPS.Contests.Views || {});
